/**
 * Properties Module Routes
 *
 * Route definitions for the Properties module.
 * All routes are relative to the module path (/properties).
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/properties',
        component: ModuleLayout,
        meta: {
            moduleKey: 'properties',
        },
        children: [
            {
                path: '',
                name: 'properties-list',
                component: () => import('./views/PropertyList.vue'),
                meta: {
                    title: 'All Properties',
                },
            },
            {
                path: 'create',
                name: 'properties-create',
                component: () => import('./views/PropertyCreate.vue'),
                meta: {
                    title: 'Add Property',
                    moduleKey: 'properties',
                },
            },
            {
                path: ':id',
                name: 'properties-detail',
                component: () => import('./views/PropertyDetail.vue'),
                meta: {
                    title: 'Property Details',
                },
            },
            {
                path: 'map',
                name: 'properties-map',
                component: () => import('./views/PropertyMap.vue'),
                meta: {
                    title: 'Property Map',
                },
            },
        ],
    },
]

export default routes
